/**
 * Константы для демо страницы CustomTableDemo
 */
import { ZOption } from "src/types/ZOption";

import { User } from "./types";

export const roleColors: Record<User["role"], string> = {
  admin: "red",
  user: "blue",
  guest: "default",
};

export const statusColors: Record<User["status"], string> = {
  active: "green",
  inactive: "default",
  pending: "orange",
};

export const roleOptions: ZOption[] = [
  { label: "Admin", value: "admin" },
  { label: "User", value: "user" },
  { label: "Guest", value: "guest" },
];

export const statusOptions: ZOption[] = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
  { label: "Pending", value: "pending" },
];
